// extracted by mini-css-extract-plugin
export default {"theme-wrapper":"_1hfS4","themeWrapper":"_1hfS4","close-button":"_2pg4c","closeButton":"_2pg4c"};